/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CarrierOwnerType = {
    Carrier: 'CARRIER',
    FleetOwner: 'FLEET_OWNER',
    OwnerOperator: 'OWNER_OPERATOR'
} as const;
export type CarrierOwnerType = typeof CarrierOwnerType[keyof typeof CarrierOwnerType];

